module.exports = __webpack_public_path__ + "img/img-5-desk.85dbf98b.jpg";